// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2c4e3e7b","453":"f040e68e"}[chunkId] + ".chunk.js";
};